
import { pt } from '../../utils/tools.js'
const monsterSprite = {
  name:"monster",
  size: {width: pt(120), height: pt(120)},
  animationTypes: ['ALL'],
  frames: [
    require('./img/1.png'),
    require('./img/2.png'),
    require('./img/3.png'),
    require('./img/4.png'),
    require('./img/5.png'),
    require('./img/6.png'),
    require('./img/7.png'),
    require('./img/8.png'),
    require('./img/9.png'),
    require('./img/10.png'),
    require('./img/11.png'),
    require('./img/12.png'),
    require('./img/13.png'),
    require('./img/14.png')
  ],
  animationIndex: function getAnimationIndex (animationType) {
    switch (animationType) {
      case 'ALL':
        return [0,1,2,3,4,5,6,7,8,9,10,11,12,13];
    }
  },
};

export default monsterSprite;
module.exports = monsterSprite;
